/*
  Крапки каруселі образів.

  Саме гортання робить CSS (scroll-snap) — скрипт лише тримає крапки
  синхронними зі скролом і дає по них перейти. Якщо JS не виконається,
  карусель усе одно гортається, просто крапки не підсвічуються.
*/

(function () {
  'use strict';

  function init(root) {
    const track = root.querySelector('[data-look-carousel]');
    const dotsBox = root.querySelector('[data-look-dots]');
    if (!track || !dotsBox || track.dataset.carouselReady === 'true') return;

    const pages = Array.from(track.querySelectorAll('.lk-grid__page'));
    const dots = Array.from(dotsBox.querySelectorAll('[data-look-page]'));
    if (pages.length < 2 || dots.length !== pages.length) return;

    track.dataset.carouselReady = 'true';

    function setActive(index) {
      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle('is-active', on);
        if (on) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    // Активною вважаємо сторінку, якої видно найбільше — на межі свайпу
    // це дає той самий результат, що й око користувача.
    const observer = new IntersectionObserver(
      (entries) => {
        let best = null;
        entries.forEach((entry) => {
          if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
        });
        if (best && best.intersectionRatio > 0.5) {
          setActive(pages.indexOf(best.target));
        }
      },
      { root: track, threshold: [0.25, 0.5, 0.75, 1] }
    );

    pages.forEach((page) => observer.observe(page));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        // scrollTo, а не scrollIntoView: той тягне за собою і вертикальну
        // прокрутку сторінки, вириваючи секцію з-під пальця.
        track.scrollTo({
          left: pages[i].offsetLeft - pages[0].offsetLeft,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
        setActive(i);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-section-id]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Кастомайзер перерендерює секцію — вішаємось наново
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
